/* How numbers, dates and sizes read in the reader's own language. No dashes
 * in anything a customer reads (CLAUDE.md), which is why ranges are words. */

export const count = (n) => n.toLocaleString();

export function size(bytes) {
  if (bytes >= 1e9) return `${(bytes / 1e9).toFixed(1)} GB`;
  if (bytes >= 1e6) return `${(bytes / 1e6).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1e3))} KB`;
}

/** A list date: the time today, day and month this year, a full date before that. */
export function shortDate(ms, now = new Date()) {
  if (ms === null || ms === undefined) return "";
  const date = new Date(ms);

  if (date.toDateString() === now.toDateString()) {
    return date.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
  }

  return date.toLocaleDateString(undefined, date.getFullYear() === now.getFullYear()
    ? { day: "numeric", month: "short" }
    : { day: "numeric", month: "short", year: "numeric" });
}

export function longDate(value) {
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? String(value)
    : date.toLocaleString(undefined, { dateStyle: "full", timeStyle: "short" });
}

export function person(p) {
  if (!p) return "";
  if (p.name && p.address) return `${p.name} <${p.address}>`;
  return p.name || p.address || "";
}

/** A file name from a subject: no characters a file system refuses, not too long. */
export function safeFileName(text, fallback = "message") {
  const cleaned = (text || "").replace(/[\\/:*?"<>|\u0000-\u001f]+/g, " ").replace(/\s+/g, " ").trim().slice(0, 120);
  return cleaned || fallback;
}
